import { render, staticRenderFns } from "./ProcessTypeAlert.vue?vue&type=template&id=0fdeb81a"
import script from "./ProcessTypeAlert.vue?vue&type=script&lang=js"
export * from "./ProcessTypeAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports